export var ViewChartTypes;

(function (ViewChartTypes) {
  ViewChartTypes["GAUGE"] = "gauge";
  ViewChartTypes["ICON"] = "icon";
  ViewChartTypes["SCALE"] = "scale";
  ViewChartTypes["VALUE"] = "value";
})(ViewChartTypes || (ViewChartTypes = {}));

export var DrilldownLevels;

(function (DrilldownLevels) {
  DrilldownLevels["YEAR"] = "year";
  DrilldownLevels["MONTH"] = "month";
  DrilldownLevels["WEEK"] = "week";
  DrilldownLevels["DAY"] = "day";
  DrilldownLevels["HOUR"] = "hour";
})(DrilldownLevels || (DrilldownLevels = {}));

export var MetricUnitLabels;

(function (MetricUnitLabels) {
  MetricUnitLabels["SECONDS"] = "seconds";
  MetricUnitLabels["MINUTES"] = "minutes";
  MetricUnitLabels["HOURS"] = "hours";
  MetricUnitLabels["DAYS"] = "days";
  MetricUnitLabels["WEEKS"] = "weeks";
  MetricUnitLabels["POINTS"] = "points";
  MetricUnitLabels["CONTACTS"] = "contacts";
})(MetricUnitLabels || (MetricUnitLabels = {}));

export var DrilldownLevelsList = [DrilldownLevels.YEAR, DrilldownLevels.MONTH, DrilldownLevels.WEEK, DrilldownLevels.DAY, DrilldownLevels.HOUR];
export var SentimentColor;

(function (SentimentColor) {
  SentimentColor["HAPPY"] = "happy";
  SentimentColor["SATISFIED"] = "satisfied";
  SentimentColor["CONTENT"] = "content";
  SentimentColor["DISSATISFIED"] = "dissatisfied";
  SentimentColor["UNHAPPY"] = "unhappy";
})(SentimentColor || (SentimentColor = {}));

export var SentimentColors = [SentimentColor.UNHAPPY, SentimentColor.DISSATISFIED, SentimentColor.CONTENT, SentimentColor.SATISFIED, SentimentColor.HAPPY];
export var SurveysDimension;

(function (SurveysDimension) {
  SurveysDimension["POSITIVE"] = "positive";
  SurveysDimension["NEGATIVE"] = "negative";
})(SurveysDimension || (SurveysDimension = {}));

export var CardTypeIcons;

(function (CardTypeIcons) {
  CardTypeIcons["PIE"] = "pie";
  CardTypeIcons["DIAGRAM"] = "diagram";
  CardTypeIcons["LINE_CHART"] = "line_chart";
})(CardTypeIcons || (CardTypeIcons = {}));

export * from './old-consts'; //todo rm